module.exports = __webpack_public_path__ + "media/images/icons/filled/wechat-696cfb774e7f9724ad9be9b247a017ce.svg";